import './App.css';
import SplashCursor from './Splash-Cursor';

function App() {
  return (
    <SplashCursor />
  );
}

export default App;
